import { useColors } from '../../hooks/useColors'

export default function OrderTimeline({ events }: { events: Array<{ id?: string; event?: string; created_at?: string }> }) {
  const colors = useColors()
  if (!events?.length) return null
  return (
    <div style={{ margin: '8px 32px 0', background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 12 }}>
      <h4 style={{ margin: '0 0 8px', color: colors.textPrimary }}>Order Timeline</h4>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {events.map((e, idx) => (
          <li key={e.id || `${e.event || 'evt'}-${idx}`} style={{ color: colors.textMuted, marginBottom: 4 }}>
            {e.event || 'updated'} {e.created_at ? `• ${new Date(e.created_at).toLocaleString()}` : ''}
          </li>
        ))}
      </ul>
    </div>
  )
}
